import { X } from "lucide-react";
import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { Tooltip } from "@mui/material";

const ProductInfoSidebar = ({
  selectedProduct,
  isVisible,
  onClose,
  BASE_URL,
}) => {
  const [branchData, setBranchData] = useState([]);
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_BASE_URL = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}`;

  const { request, loading } = useApi();
  useEffect(() => {
    if (!isVisible || !selectedProduct) {
      setBranchData([]);
      return;
    }
    console.log("selectedProduct", selectedProduct);
    const safeProductId =
      selectedProduct?.Code?.toString().replace(/\//g, "%2F") || "";

    const fetchBranchData = async () => {
      try {
        const url = `${API_BASE_URL}/LOCATIONSTOCK/${safeProductId}/-/-`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        setBranchData(response || []);
      } catch (err) {
        setBranchData([]);
      }
    };

    fetchBranchData();
  }, [selectedProduct, isVisible, API_BASE_URL]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape" && isVisible) {
        onClose();
      }
    };

    if (isVisible) {
      window.addEventListener("keydown", handleEsc);
    }
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isVisible, onClose]);

  const sortedBranchData = [...branchData]?.sort((a, b) => b.Qty - a.Qty);

  return (
    <div
      className={`fixed top-0 right-0 w-48 h-full bg-white shadow-lg border-l border-gray-300 z-40 transform transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className=" h-full flex flex-col overflow-y-auto scrollbar-thin relative">
        <div className="mb-2 pb-2 p-2 border-b border-gray-200 flex justify-between items-center  sticky top-0 bg-white z-10">
          {selectedProduct && (
            <p className="text-sm text-gray-600 break-words break-all">
              {selectedProduct?.name ||
                selectedProduct?.Code ||
                selectedProduct?.code ||
                "N/A"}
            </p>
          )}
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-1 bg-gray-100 rounded ml-2"
            aria-label="Close sidebar"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex-1 min-h-0 p-3">
          {loading ? (
            <div className="text-center text-gray-500 py-4">Loading...</div>
          ) : (
            <div className="grid grid-cols-1 gap-2 mb-3">
              {sortedBranchData?.map((branch, index) => (
                <div
                  key={branch.LOC}
                  className={`p-2 rounded border text-xs ${
                    branch.Qty > 0
                      ? "border-green-200 bg-green-50"
                      : "border-red-200 bg-red-50"
                  }`}
                >
                  <div className="flex justify-between items-center mb-1">
                    <Tooltip title={branch.LOC} placement="top">
                      <span className="font-semibold text-blue-700 text-xs line-clamp-1">
                        {branch.LOC}
                      </span>
                    </Tooltip>
                  </div>
                  <div className="grid grid-cols-2 gap-1 text-xs">
                    <div className=" col-span-1">
                      <span className="text-gray-500">Qty:</span>
                      <span
                        className={` ${
                          branch.Qty > 0
                            ? "text-green-500 font-bold"
                            : "text-red-500 font-bold"
                        }`}
                      >
                        {branch.Qty}
                      </span>
                    </div>
                    <div className=" col-span-1">
                      <span className="text-gray-500">Bin:</span>
                      <span className=" font-medium">{branch.BIN}</span>
                    </div>
                  </div>
                </div>
              ))}
              {sortedBranchData?.length === 0 && (
                <div className="text-center text-gray-500 text-xs py-2">
                  No data available.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductInfoSidebar;
